// Remove this file during sign_core_2025_12_08_white_labeling_swap FF cleanup
import { defineMessages, useIntl } from 'react-intl';
import { useMemo } from 'react';
import { AccordionColorPickerSection } from './accordion-color-picker';
import { type WhiteLabelingPropertyIdOld } from 'js/sign-components/common/white-labeling-old';

const messages = defineMessages({
  primaryButtonSectionLabel: {
    id: '',
    description: 'Primary Button sectionLabel',
    defaultMessage: 'Primary button colors',
  },
  primaryButtonColorLabel: {
    id: '',
    description: 'Primary Button color label',
    defaultMessage: 'Primary button color',
  },
  primaryButtonTextColorLabel: {
    id: '',
    description: 'Primary Button text color label',
    defaultMessage: 'Primary button text color',
  },
  primaryButtonHoverColorLabel: {
    id: '',
    description: 'Primary Button hover color label',
    defaultMessage: 'Primary button hover color',
  },
  backgroundColorsSectionLabel: {
    id: '',
    description: 'Background Color sectionLabel',
    defaultMessage: 'Background colors',
  },
  headerBackgroundColorLabel: {
    id: '',
    description: 'Header background color label',
    defaultMessage: 'Header background color',
  },
  textColorsSectionLabel: {
    id: '',
    description: 'Text Colors Section Label',
    defaultMessage: 'Text colors',
  },
  linkColorLabel: {
    id: '',
    description: 'Link Color Label',
    defaultMessage: 'Link color',
  },
});
export const useSectionsOld = () => {
  const intl = useIntl();

  return useMemo<AccordionColorPickerSection<WhiteLabelingPropertyIdOld>[]>(
    () => [
      {
        sectionId: 'primary-button',
        sectionLabel: intl.formatMessage(messages.primaryButtonSectionLabel),
        items: [
          {
            id: 'primary_button_color',
            label: intl.formatMessage(messages.primaryButtonColorLabel),
          },
          {
            id: 'primary_button_text_color',
            label: intl.formatMessage(messages.primaryButtonTextColorLabel),
          },
          {
            id: 'primary_button_color_hover',
            label: intl.formatMessage(messages.primaryButtonHoverColorLabel),
          },
        ],
      },
      {
        sectionId: 'background-color',
        sectionLabel: intl.formatMessage(messages.backgroundColorsSectionLabel),
        items: [
          {
            id: 'header_background_color',
            label: intl.formatMessage(messages.headerBackgroundColorLabel),
          },
        ],
      },
      {
        sectionId: 'text-color',
        sectionLabel: intl.formatMessage(messages.textColorsSectionLabel),
        items: [
          {
            id: 'link_color',
            label: intl.formatMessage(messages.linkColorLabel),
          },
        ],
      },
    ],
    [intl],
  );
};
